import { render, staticRenderFns } from "./OrganizationDueDated.vue?vue&type=template&id=626f991a"
import script from "./OrganizationDueDated.vue?vue&type=script&lang=js"
export * from "./OrganizationDueDated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports